import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'  

// material-ui
import { useTheme } from '@mui/material/styles'
import { useMediaQuery, Box, Toolbar } from '@mui/material'

// project import
import { useUserContext } from '../../context/UserContext'

import Drawer from './Drawer'
import Header from './Header'
import HorizontalBar from './Drawer/HorizontalBar'

import useConfig from 'hooks/useConfig'
import { MenuOrientation } from 'config'
import menuItems from 'menu-items/index'                 

// ==============================|| MAIN LAYOUT ||============================== //

const DashboardLayout = () => {
  const { updateDrawerOpen } = useUserContext()
  const theme = useTheme()
  const matchDownXL = useMediaQuery(theme.breakpoints.down('xl'))
  const downLG = useMediaQuery(theme.breakpoints.down('lg'))

  const { miniDrawer, menuOrientation } = useConfig()
  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG

  const location = useLocation()                         

  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      updateDrawerOpen(!matchDownXL)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownXL])

  // ---------- dynamic browser tab title based on current menu ----------
  useEffect(() => {
    // flatten nested menu structure (DashboardMenu, AppointmentMenu, etc.)
    const collectItems = (nodes, acc = []) => {
      nodes.forEach((node) => {
        if (node.url) acc.push(node)
        if (node.children && node.children.length) {
          collectItems(node.children, acc)
        }
      })
      return acc
    }

    const allItems = collectItems(menuItems.items || [])

    const current = allItems.find((item) => item.url === location.pathname)

    if (current?.title === 'Schedule') {
      document.title = 'Appointment'
      return
    }

    if (current && current.title) {
      document.title = `${current.title}`
    } else {
      document.title = 'Appointment'
    }
  }, [location.pathname])

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header />
      {!isHorizontal ? <Drawer /> : <HorizontalBar />}

      <Box component="main" sx={{ width: '100%', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  )
}

export default DashboardLayout
